//import Page from "./Page";

export default class Menu {
	constructor (menuType) {


		if ( menuType == 'submenu' )
		{
			this.btnOpen = document.getElementById('btn_open_submenu');
			this.btnClose = document.getElementById('btn_close_submenu');
			this.container = document.getElementById('submenu_container');
		}
		else
		{
			this.btnOpen = document.getElementById('btn_open_menu');
			this.btnClose = document.getElementById('btn_close_menu');
			this.container = document.getElementById('menu_container');
		}

		if ( this.btnOpen && this.btnClose && this.container )
		{
			this.bindEvents();

			let mql = window.matchMedia("(min-width: 768px)");
			mql.addListener( this.switchMedia.bind(this) );
			this.switchMedia( mql );
		}
	}

	bindEvents () {
		this.btnOpen.addEventListener('click', this.open.bind(this));
		this.btnClose.addEventListener('click', this.close.bind(this));
	}

	open () {
		console.log('open()')
		Menu.addClass(this.container, 'is-visible');
	}

	close () {

		console.log('close()')
		Menu.removeClass(this.container, 'is-visible');
	}

	switchMedia ( mql ) {
		this.close();
	}


	static addClass (el, className) {
		if ( !el.classList.contains(className) )
		{
			el.classList.add(className);
		}
	}

	static removeClass (el, className) {
		if ( el.classList.contains(className) )
		{
			el.classList.remove(className);
		}
	}

	static hasClass (el, className) {
		return el.classList.contains(className);
	}

}